import { Button, Grid, Stack, Typography, Box } from "@mui/material";
import { MotionContainer, varBounce } from "../../../components/minimal/animate";
import { m } from "framer-motion";
import SuccessIllustration from "../../../assets/illustrations/SuccessIllustration";
import { useLocales } from "../../../locales";
import { useEventContext } from "../../../context-state/EventContext";

export const SuccessMsg = () => {

    const { translate } = useLocales()
    const { eventPageContext } = useEventContext()
    const { event, account, tickets } = eventPageContext
    const refreshPage = () => window.location.reload()
    const { thankYouForYourOrderText, thankYouForYourOrderImage } = account.marketPlace

    return (
        <Grid item sx={{ margin: "20px auto", p: 2, textAlign: "center" }}>
            <Stack alignItems="center" component={MotionContainer}>

                <m.div variants={varBounce().in}>
                    <Typography variant="h4" paragraph sx={{ color: 'text.secondary' }}>
                        {thankYouForYourOrderText || translate('event_page.order_success')}
                    </Typography>
                </m.div>

                <m.div variants={varBounce().in}>
                    <Typography sx={{ color: 'text.secondary' }}>
                        {
                            event.is_manual_approve_buyer ? translate('event_page.order_waiting_for_approval') : translate('event_page.ticket_by_mail')
                        }
                    </Typography>
                </m.div>



                <m.div variants={varBounce().in}>
                    <Box sx={{ my: 5}}>
                        {thankYouForYourOrderImage && <img style={{maxHeight: "60vh"}} src={thankYouForYourOrderImage} alt="thankYouForYourOrderImage" />}
                        {!thankYouForYourOrderImage && <SuccessIllustration/>}
                    </Box>
                </m.div>
                <m.div variants={varBounce().in}>
                    <Button onClick={refreshPage} sx={{ width: "100%" }} size="large" variant="outlined">
                        {translate('event_page.new_order')}
                    </Button>
                </m.div>
            </Stack>
        </Grid>
    )
}
